import { FlexBox, Text } from '@dixa/lib-shared-habla';

import { localizeMessageTimestamps } from '../../../../../../utils/localizeTimestamps';

import styles from './sidekickChoices.module.scss';

type SidekickChoicesProps = {
  choices: string[];
  onSelect: (choice: string) => void;
};

/** Render this component when structured output present us with choices */
export const SidekickChoices = ({
  choices,
  onSelect,
}: SidekickChoicesProps): JSX.Element | null => {
  if (choices.length === 0) return null;

  return (
    <FlexBox flexDirection="column" gap="100">
      {choices.map((choice) => (
        <FlexBox
          key={choice}
          as="button"
          className={styles.choiceCard}
          onClick={() => onSelect(choice)}
        >
          <Text.Paragraph as="span" variant="3" wrap="normal" color="inherit">
            {localizeMessageTimestamps(choice)}
          </Text.Paragraph>
        </FlexBox>
      ))}
    </FlexBox>
  );
};
